module.exports = __webpack_public_path__ + "static/parade-2019-house14-2704882c36f3dad25fd6cc5721adb139.jpg";